import { createStore } from 'satcheljs';
import { ObservableMap } from 'mobx';
import type TableViewConversationRelation from './schema/TableViewConversationRelation';
import type TableViewItemRelation from './schema/TableViewItemRelation';
import type ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import type ConversationItem from './schema/ConversationItem';
import type TableView from './schema/TableView';
import type ListViewStore from './schema/ListViewStore';

const listViewDefaultStore: ListViewStore = {
    conversationItems: new ObservableMap<string, ConversationItem>({}),
    selectedTableViewId: null,
    tableViewConversationRelations: new ObservableMap<string, TableViewConversationRelation>({}),
    tableViewItemRelations: new ObservableMap<string, TableViewItemRelation>({}),
    tableViews: new ObservableMap<string, TableView>({}),
    meetingMessageItems: new ObservableMap<string, ClientItem>({}),
    shouldShowSearchBox: false,
    shouldShowOtherInboxUpdate: false,
    shouldShowAutomaticRepliesBanner: false,
    canAllotSpaceForFocusedOtherCampaign: true,
    showUpNext: false,
    showUSQWarningCard: true,
    onboardingCardsHeight: 0,
};

const getListViewStore = createStore<ListViewStore>('listview', listViewDefaultStore);

const listViewStore = getListViewStore();

export default listViewStore;

export { getListViewStore, ListViewStore };
